console.log('asdasd');


<!-- Taboola Pixel Code -->

    window._tfa = window._tfa || [];
    window._tfa.push({notify: 'event', name: 'page_view', id: 1768976});
    !function (t, f, a, x) {
        if (!document.getElementById(x)) {
            t.async = 1;t.src = a;t.id=x;f.parentNode.insertBefore(t, f);
        }
    }(document.createElement('script'),
        document.getElementsByTagName('script')[0],
        '//cdn.taboola.com/libtrc/unip/1768976/tfa.js',
        'tb_tfa_script');

<!-- End of Taboola Pixel Code -->


const allButtons = document.querySelectorAll('.button.button--primary');
allButtons.forEach((link) => {
    link.addEventListener("click", function () {
        window._tfa.push({notify: 'event', name: 'btn_click', id: 1768976});
        return false;
    });
});





